// AUTO-GENERATED SQL Builder (V40 Final) for OfferingPackage
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class OfferingPackageSql {
  private ast = new SqlAst('OfferingPackage', 'offeringPackage');
  public readonly main: any = {};

  public guid: SqlField;
  public offeringId: SqlField;
  public name: SqlField;
  public basePrice: SqlField;
  public extraPerHead: SqlField;
  public chooseCount: SqlField;
  public sortOrder: SqlField;
  public createdByUser: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public bookingPackageByBundleOfferingPackageList: SqlNavHybrid;
  public bookingPackageByOfferingPackageList: SqlNavHybrid;
  public offeringIncludeList: SqlNavHybrid;
  public offeringMilestoneList: SqlNavHybrid;
  public packageItemByOfferingPackageList: SqlNavHybrid;
  public packageItemBySrcOfferingPackageList: SqlNavHybrid;
  public packageOptionList: SqlNavHybrid;
  public resaleList: SqlNavHybrid;
  public resaleTermList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('offeringPackage', 'guid', '', 'id', 'offeringPackage_guid');
    this.offeringId = new SqlField('offeringPackage', 'offeringId', 'offering', 'id', 'offeringPackage_offering');
    this.name = new SqlField('offeringPackage', 'name', '', 'id', 'offeringPackage_name');
    this.basePrice = new SqlField('offeringPackage', 'basePrice', '', 'id', 'offeringPackage_basePrice');
    this.extraPerHead = new SqlField('offeringPackage', 'extraPerHead', '', 'id', 'offeringPackage_extraPerHead');
    this.chooseCount = new SqlField('offeringPackage', 'chooseCount', '', 'id', 'offeringPackage_chooseCount');
    this.sortOrder = new SqlField('offeringPackage', 'sortOrder', '', 'id', 'offeringPackage_sortOrder');
    this.createdByUser = createNavHybrid('offeringPackage', 'offeringPackage_createdByUser', 'User');
    this.offering = createNavHybrid('offeringPackage', 'offeringPackage_offering', 'Offering');
    this.updatedByUser = createNavHybrid('offeringPackage', 'offeringPackage_updatedByUser', 'User');
    this.bookingPackageByBundleOfferingPackageList = createNavHybrid('offeringPackage', 'offeringPackage_bookingPackageByBundleOfferingPackageList', 'BookingPackage');
    this.bookingPackageByOfferingPackageList = createNavHybrid('offeringPackage', 'offeringPackage_bookingPackageByOfferingPackageList', 'BookingPackage');
    this.offeringIncludeList = createNavHybrid('offeringPackage', 'offeringPackage_offeringIncludeList', 'OfferingInclude');
    this.offeringMilestoneList = createNavHybrid('offeringPackage', 'offeringPackage_offeringMilestoneList', 'OfferingMilestone');
    this.packageItemByOfferingPackageList = createNavHybrid('offeringPackage', 'offeringPackage_packageItemByOfferingPackageList', 'PackageItem');
    this.packageItemBySrcOfferingPackageList = createNavHybrid('offeringPackage', 'offeringPackage_packageItemBySrcOfferingPackageList', 'PackageItem');
    this.packageOptionList = createNavHybrid('offeringPackage', 'offeringPackage_packageOptionList', 'PackageOption');
    this.resaleList = createNavHybrid('offeringPackage', 'offeringPackage_resaleList', 'Resale');
    this.resaleTermList = createNavHybrid('offeringPackage', 'offeringPackage_resaleTermList', 'ResaleTerm');
    this.id = new SqlField('offeringPackage', 'id', '', 'id', 'offeringPackage_id');
    this.isDeleted = new SqlField('offeringPackage', 'isDeleted', '', 'id', 'offeringPackage_isDeleted');
    this.createdBy = new SqlField('offeringPackage', 'createdBy', '', 'id', 'offeringPackage_createdBy');
    this.createdDate = new SqlField('offeringPackage', 'createdDate', '', 'id', 'offeringPackage_createdDate');
    this.updatedBy = new SqlField('offeringPackage', 'updatedBy', '', 'id', 'offeringPackage_updatedBy');
    this.updatedDate = new SqlField('offeringPackage', 'updatedDate', '', 'id', 'offeringPackage_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:OfferingPackageSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:OfferingPackageSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:OfferingPackageSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:OfferingPackageSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:OfferingPackageSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:OfferingPackageSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:OfferingPackageSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:OfferingPackageSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:OfferingPackageSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:OfferingPackageSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
